import { Chip, ChipProps, FormControl, InputLabel, MenuItem, Select } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { TASK_WORKFLOW_STATUSES, TaskWorkflowStatus } from '../../types/entities/task.entity';

export const WORKFLOW_STATUS_COLORS: Record<TaskWorkflowStatus, ChipProps['color']> = {
    todo: 'default',
    in_progress: 'info',
    blocked: 'error',
    done: 'success',
};

export const useWorkflowStatusLabel = () => {
    const { t } = useTranslation();
    return (status: TaskWorkflowStatus | undefined | null) => t(`workflow.status.${status ?? 'todo'}`);
};

export const WorkflowStatusChip = ({ status, size = 'small', onClick }: {
    status: TaskWorkflowStatus | undefined | null;
    size?: ChipProps['size'];
    onClick?: ChipProps['onClick'];
}) => {
    const label = useWorkflowStatusLabel();
    const value = status ?? 'todo';
    return <Chip size={size} color={WORKFLOW_STATUS_COLORS[value]} label={label(value)} onClick={onClick} />;
};

export const WorkflowStatusSelect = ({ value, onChange, size, label, fullWidth = true, disabled }: {
    value: TaskWorkflowStatus;
    onChange: (value: TaskWorkflowStatus) => void;
    size?: 'small' | 'medium';
    label?: string;
    fullWidth?: boolean;
    disabled?: boolean;
}) => {
    const { t } = useTranslation();
    const fieldLabel = label ?? t('workflow.statusLabel');
    return (
        <FormControl fullWidth={fullWidth} size={size} disabled={disabled}>
            <InputLabel>{fieldLabel}</InputLabel>
            <Select
                value={value}
                label={fieldLabel}
                onChange={(event) => onChange(event.target.value as TaskWorkflowStatus)}
                onClick={(event) => event.stopPropagation()}
                renderValue={(selected) => <WorkflowStatusChip status={selected as TaskWorkflowStatus} />}
            >
                {TASK_WORKFLOW_STATUSES.map((status) => (
                    <MenuItem key={status} value={status}>
                        <WorkflowStatusChip status={status} />
                    </MenuItem>
                ))}
            </Select>
        </FormControl>
    );
};
